import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useChatWidget } from '@/context/ChatWidgetContext';
import { prefetchChatWidget } from './ChatWidgetOverlay';

/**
 * Site-wide chat entry point. Hidden on /chat (that page already is
 * full-screen chat) and while the overlay itself is open. Sits higher than
 * PushPrompt/InstallPrompt's bottom-4 corner cards so it doesn't stack
 * directly on top of them when both happen to be visible.
 */
export function ChatWidgetFab() {
  const location = useLocation();
  const { isOpen, openWidget } = useChatWidget();

  if (location.pathname === '/chat' || isOpen) return null;

  return (
    <button
      onClick={() => openWidget()}
      // The overlay is a lazy chunk; warm it the moment the user shows intent
      // so the click opens straight into the widget rather than the skeleton.
      onPointerEnter={prefetchChatWidget}
      onPointerDown={prefetchChatWidget}
      onFocus={prefetchChatWidget}
      aria-label="Chat with an AI astrologer"
      className="fixed bottom-24 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-cosmic-500 text-white shadow-lg shadow-primary-500/40 transition-transform hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" />
    </button>
  );
}
